import { render } from "./PaymentVA.vue?vue&type=template&id=358ae71f"
import script from "./PaymentVA.vue?vue&type=script&lang=js"
export * from "./PaymentVA.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__